export default __webpack_public_path__ + "static/media/tac.57b64b1f.mp3";